module.exports = {"610331100":"咀头镇","610331101":"桃川镇","610331102":"鹦鸽镇","610331103":"靖口镇","610331104":"太白河镇","610331105":"黄柏塬镇","610331106":"王家堎镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610331.json
// module id = 2597
// module chunks = 0